import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { DialogStyled, FormTextFieldController } from '@/components';

type DialogAddKitchenNoteProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  initialNote?: string;
  onSave: (newNote?: string) => void;
};

type FormData = {
  note: string;
};

const schema = z.object({
  note: z.string(),
});

export const DialogAddKitchenNote = ({
  open,
  setOpen,
  initialNote,
  onSave,
}: DialogAddKitchenNoteProps) => {
  const { t } = useTranslation();
  const methods = useForm<FormData>({
    defaultValues: {
      note: initialNote ?? '',
    },
    resolver: zodResolver(schema),
  });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (data: FormData) => {
    onSave(data.note);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <FormProvider {...methods}>
      <DialogStyled
        open={open}
        setOpen={setOpen}
        title={t('VARIANT.KITCHEN_NOTE_TITLE')}
        onActionButtonClick={handleSubmit(onSubmit)}
        onClose={handleClose}
      >
        <FormTextFieldController
          label={t('VARIANT.KITCHEN_NOTE_LABEL')}
          controllerName={'note'}
          minRows={2}
          error={!!errors.note}
          errorText={t('ERRORS.FIELD_REQUIRED')}
          helperText={t('VARIANT.KITCHEN_NOTE_HELPER')}
        />
      </DialogStyled>
    </FormProvider>
  );
};
